// Shared by the restock correction screen and its sections - used with useThemedStyles.
export const createCorrectMarketRestockStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		flex: 1,
		backgroundColor: colors.canvas,
	},
	content: {
		paddingHorizontal: space.gutter,
		paddingTop: 20,
		paddingBottom: space.xl,
		gap: space.md,
	},
	headingBlock: {
		gap: 6,
	},
	title: {
		...type.title,
		color: colors.text,
	},
	marketName: {
		...type.bodySmall,
		color: colors.textSecondary,
	},
	intro: {
		...type.bodySmall,
		color: colors.textSecondary,
	},
	notice: {
		...type.bodySmall,
		color: colors.text,
	},
	sectionTitle: {
		...type.sectionTitle,
		color: colors.text,
		marginTop: space.sm,
	},
	followUpQuestion: {
		...type.sectionTitle,
		color: colors.text,
	},
	productCard: {
		gap: space.md,
	},
	productName: {
		...type.rowTitleSemibold,
		color: colors.text,
		flexShrink: 1,
	},
	quantityRow: {
		flexDirection: 'row',
		alignItems: 'flex-end',
		gap: space.xl,
	},
	statRow: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: space.md,
	},
	stat: {
		flex: 1,
		minWidth: 88,
	},
	statValue: {
		...type.bodyStrong,
		color: colors.text,
	},
	varianceValue: {
		...type.hero,
		color: colors.text,
	},
	correctedQuantity: {
		marginLeft: 'auto',
	},
	fieldLabel: {
		...type.caption,
		color: colors.textSecondary,
		marginBottom: space.xs,
	},
	quantityInput: {
		width: 88,
	},
	batchField: {
		gap: space.xs,
	},
	hint: {
		...type.caption,
		color: colors.textSecondary,
	},
	previewReasonText: {
		...type.bodySmall,
		color: colors.text,
	},
	reasonInput: {
		minHeight: 96,
	},
	historyCard: {
		gap: space.xs,
	},
	historyTitle: {
		...type.bodySmallSemibold,
		color: colors.text,
	},
	historyChange: {
		...type.secondary,
		color: colors.text,
	},
	dockRow: {
		flexDirection: 'row',
		gap: space.sm,
	},
	dockButton: {
		flex: 1,
		minHeight: 48,
	},
	dockCancel: {
		minHeight: 48,
	},
});
